// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25yt5","toggleWrap":"styles_toggleWrap__3WtGp","content":"styles_content__77JKD","selectAreaCode":"styles_selectAreaCode__1CJTQ"};